import { useEffect } from "react";
import { useNavigate } from "react-router";

const platform = require("platform");
const isiOS = platform.os.family === "iOS";

const NativeAppMessaging = ({ onNativeMessageReceived }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.navigateTo = (url) => navigate(url);

    let messageHandler = (event) => {
      let eventDataObj = null;
      try {
        eventDataObj = JSON.parse(event.data);

        if (!eventDataObj.type) return;
        if (
          eventDataObj.type === "RN_NATIVE_CREDENTIALS" &&
          eventDataObj.payload
        )
          localStorage.setItem(
            "nativeCredentials",
            JSON.stringify(eventDataObj.payload.credentials)
          );

        if (eventDataObj.type.startsWith("RN_"))
          onNativeMessageReceived(eventDataObj);
        //eslint-disable-next-line
      } catch (error) {}
    };

    if (isiOS)
      window.addEventListener(
        "message",
        (event) => messageHandler(event),
        false
      );
    else
      document.addEventListener(
        "message",
        (event) => messageHandler(event),
        false
      );
  }, [navigate]);

  return null;
};

export default NativeAppMessaging;
